<template>
  <div class="login-box">
    <div class="login-logo">
      <a href>
        <b>ProCheck</b> CMS
      </a>
    </div>
    <div class="login-box-body">
      <p class="login-box-msg">ลืมรหัสผ่าน</p>
      <form @submit.prevent="submit">
        <div class="form-group has-feedback">
          <input type="text" class="form-control" v-model="username" placeholder="ชื่อผู้ใช้งาน" />
          <span class="glyphicon glyphicon-user form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input type="email"  class="form-control" v-model="email" placeholder="อีเมล" />
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-xs-8" style="padding-left: 35px;"></div>

          <div class="col-xs-4">
            <button type="submit" class="btn btn-primary btn-block btn-flat">ยืนยัน</button>
          </div>
        </div>
      </form>
      <!-- <el-dialog title="แจ้งเตือน" :visible.sync="centerDialogVisible" width="30%" center>
        <span>ระบบได้ทำการส่งรหัสผ่านใหม่ไปยังอีเมลของคุณเรียบร้อยแล้ว</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">ปิด</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">ยืนยัน</el-button>
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>

<style>
.skin-blue.sidebar-mini {
  background-color: rgb(210, 214, 222);
}
.login-box-body.register-box-body {
  background: #fff;
  padding: 20px;
  border-top: 0;
  color: #666;
}
.checkbox.radio {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      username: "",
      email: ""
    };
  },
  methods: {
        ...mapActions({
      forget:'Login_store/forget'
    }),
    submit() {
      if(!this.username){
        return this.$confirm("กรุณาระบุชื่อผู้ใช้งาน", "แจ้งเตือน", {
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                showCancelButton: false,
                type: "warning"
              })
      }else if (!this.email){
        return this.$confirm("กรุณาระบุอีเมล", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
      }
      this.forget({username:this.username,email:this.email})
    }
  }
};
</script>



